import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Telegram backgrounds WebViews aggressively. Refetching on focus gives
      // users fresh data when they re-open the Mini App after switching away.
      refetchOnWindowFocus: true,
      // When device comes back online (cell handoff on a bus), re-validate.
      refetchOnReconnect: 'always',
      retry: 1,
    },
    mutations: {
      // One retry on transient network failure for idempotent transitions.
      // Pessimistic mutations (publish, safety alert) override via their own
      // useMutation options.
      retry: 1,
      retryDelay: 300,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
